@if (scoringDefinition(); as scoringDefinition) {
  @if (disabled) {
    <crm-dropdown-panel>
      <crm-dropdown-header onState="collapsed" *ngTemplateOutlet="viewHeader"></crm-dropdown-header>
      <crm-dropdown-content onState="collapsed" *ngTemplateOutlet="viewContent"></crm-dropdown-content>

      <crm-dropdown-header onState="expanded" *ngTemplateOutlet="viewHeader"></crm-dropdown-header>
      <crm-dropdown-content onState="expanded" *ngTemplateOutlet="viewContent"></crm-dropdown-content>
    </crm-dropdown-panel>
  } @else {
    <crm-dropdown-panel [actions]="actions">
      <crm-dropdown-header onState="collapsed" *ngTemplateOutlet="viewHeader"></crm-dropdown-header>
      <crm-dropdown-content onState="collapsed" *ngTemplateOutlet="viewContent"></crm-dropdown-content>

      <crm-dropdown-header onState="expanded" *ngTemplateOutlet="editHeader"></crm-dropdown-header>
      <crm-dropdown-content onState="expanded" *ngTemplateOutlet="editContent"></crm-dropdown-content>
    </crm-dropdown-panel>
  }

  <ng-template #viewHeader>
    <div
      class="points-count"
      [class]="scoringDefinition.contribution && scoringDefinition.contribution > 0 ? 'positive' : 'negative'"
    >
      {{ 'SCORE_SETTINGS.TITLES.VIEW.POINTS' | translate: { points: scoringDefinition.contribution | formatPoints } }}
    </div>
  </ng-template>

  <ng-template #viewContent>
    @for (rule of scoringDefinition.scoringRules; track $index; let last = $last) {
      <div class="item">
        @if (rule | firstRuleFilter; as filter) {
          <span class="item--field">{{ filter.fieldId | fieldName: objectType | async }}</span>
          {{ filter.operator | operatorName }}
          @if (filter.operator | operatorValueIsRequired) {
            @if (filter.fieldId | filterOverride: objectType | async; as filterOverride) {
              <crm-scoring-definition-custom-filter-output
                class="item--custom-value"
                [filterChip]="filterOverride.filterChip"
                [initialValue]="filter.values"
              ></crm-scoring-definition-custom-filter-output>
            } @else {
              @if (filter | fieldValue: objectType | async; as value) {
                <span class="item--value">{{ value | translate }}</span>
              }
            }
          }
        }
      </div>
      @if (!last) {
        <div class="divider">{{ 'SCORE_SETTINGS.MISC.AND' | translate }}</div>
      }
    } @empty {
      <div class="item item-empty">{{ 'SCORE_SETTINGS.EMPTY_STATE.FILTERS' | translate }}</div>
    }
  </ng-template>

  <ng-template #editHeader>
    <div class="point-input">
      {{ 'SCORE_SETTINGS.TITLES.EDIT.POINTS' | translate: { sign: scoringDefinition.contribution | sign } }}
      <glxy-form-field [size]="'small'" [bottomSpacing]="'none'">
        <input matInput class="point-count-input" type="number" [formControl]="contributionCtrl" [min]="1" />
      </glxy-form-field>
    </div>
  </ng-template>

  <ng-template #editContent>
    <div class="items-container">
      @for (rule of scoringDefinition.scoringRules; track index; let index = $index) {
        @if (rule | firstRuleFilter; as filter) {
          <div class="item-card">
            <div class="item-card-header">
              <div class="item-target">{{ rule.crmObjectType }}</div>
              <button mat-icon-button class="small-icon" (click)="handleRemoveRule(index)">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="form-items">
              <crm-scoring-definition-field-id
                [objectType]="objectType"
                [value]="filter.fieldId"
                (valueChange)="setRuleFieldId(index, rule, $event)"
              ></crm-scoring-definition-field-id>

              <crm-scoring-definition-field-operator
                [objectType]="objectType"
                [fieldId]="filter.fieldId"
                [value]="filter.operator"
                (valueChange)="setRuleOperator(index, rule, $event)"
              ></crm-scoring-definition-field-operator>

              @if (objectType) {
                <crm-scoring-definition-field-value
                  [objectType]="objectType"
                  [fieldId]="filter.fieldId"
                  [operator]="filter.operator"
                  [values]="filter.values"
                  (valuesChange)="setRuleValue(index, rule, $event)"
                ></crm-scoring-definition-field-value>
              }
            </div>
          </div>
        }
      } @empty {
        <div class="item item-empty">{{ 'SCORE_SETTINGS.EMPTY_STATE.FILTERS' | translate }}</div>
      }
      <button mat-stroked-button class="add-filter-button" (click)="handleAddFilterClick()">
        <mat-icon>add</mat-icon> {{ 'SCORE_SETTINGS.CTA.ADD_FILTER' | translate }}
      </button>
    </div>
  </ng-template>
}
